import { useMemo } from 'react'

export const useGridFiltering = ({
  rows = [],
  columns = [],
  searchValue = '',
  columnFilters = {},
  statusField = 'companyStatus',
}) => {
  return useMemo(() => {
    let filteredRows = [...rows]

    // ---------- GLOBAL SEARCH ----------
    if (searchValue) {
      const s = searchValue.toLowerCase()

      filteredRows = filteredRows.filter((row) =>
        columns.some((col) => {
          const value = col.valueGetter
            ? col.valueGetter({ row })
            : row[col.field]

          return value?.toString().toLowerCase().includes(s)
        })
      )
    }

    // ---------- COLUMN FILTERS ----------
    Object.entries(columnFilters).forEach(([field, values]) => {
      if (!Array.isArray(values) || values.length === 0) return

      filteredRows = filteredRows.filter((row) => {
        // Status → always compare raw value
        if (field === statusField) {
          return values.includes(row[field])
        }

        return values.includes(row[field])
      })
    })

    return filteredRows
  }, [rows, columns, searchValue, columnFilters, statusField])
}
